<script>
  import { user } from "../../stores/User"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { navigate } from "svelte-routing"
  import Spinner from "../../components/Spinner.svelte"
  import { createEventDispatcher } from "svelte"

  const dispatch = createEventDispatcher()

  export let documento

  let data = {
    persona: undefined,
    loading: false,
  }

  let session_key = $user.session_key

  const buscarPersona = async () => {
    const ops = "general_datos"
    let url = `${BASE_URL}persona.php?documento=${documento}&session_key=${session_key}&ops=${ops}`
    data.loading = true
    const response = await fetch(url)
    const resp = await response.json()

    if (resp.data.error_id !== undefined) {
      alert(resp.data.message)
      navigate("/", { replace: true })
    }

    data = {
      persona: resp.data,
      loading: false,
    }

    data.persona.edad = calcularEdad(data.persona.nacimiento)
    dispatch("loaded", data.persona)
  }

  const calcularEdad = (fechaNacimiento) => {
    const hoy = new Date()
    const [anio, mes, dia] = fechaNacimiento.split("-").map(Number)

    const nacimiento = new Date(anio, mes - 1, dia)

    if (isNaN(nacimiento.getTime())) {
      return ""
    }

    let edad = hoy.getFullYear() - nacimiento.getFullYear()

    const mesNacimiento = nacimiento.getMonth()
    const diaNacimiento = nacimiento.getDate()
    const mesActual = hoy.getMonth()
    const diaActual = hoy.getDate()

    if (
      mesActual < mesNacimiento ||
      (mesActual === mesNacimiento && diaActual < diaNacimiento)
    ) {
      edad--
    } else {
      console.log("Día actual: " + diaActual)
      console.log("Día nacimiento: " + diaNacimiento)
    }

    if (edad < 0 || edad > 130) {
      return ""
    }

    return edad
  }

  buscarPersona()
</script>

<div class="row">
  {#if data.loading === true}
    <Spinner />
  {:else if data.persona !== undefined}
    <div class="col-12 lg:col-6">
      <div class="table-responsive">
        <table class="table table-striped table-sm">
          <tbody>
            <tr>
              <th class="fg-secondary fw-normal">Nacimiento</th>
              <td>{data.persona.nacimiento}</td>
            </tr>
            <tr>
              <th class="fg-secondary fw-normal">Nacionalidad</th>
              <td>{data.persona.nacionalidad}</td>
            </tr>
            <tr>
              <th class="fg-secondary fw-normal">Sexo</th>
              <td>{data.persona.sexo}</td>
            </tr>
            <tr>
              <th class="fg-secondary fw-normal">Estado Civil</th>
              <td>{data.persona.estado_civil}</td>
            </tr>
            <tr>
              <th class="fg-secondary fw-normal">Ubicación</th>
              <td>{data.persona.ubicacion}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-12 lg:col-6">
      <div class="table-responsive">
        <table class="table table-striped table-sm">
          <tbody>
            <tr>
              <th class="fg-secondary fw-normal">Nivel de Educación</th>
              <td>{data.persona.nivel_educacion}</td>
            </tr>
            <tr>
              <th class="fg-secondary fw-normal">Madre</th>
              <td>{data.persona.madre}</td>
            </tr>
            <tr>
              <th class="fg-secondary fw-normal">Padre</th>
              <td>{data.persona.padre}</td>
            </tr>
            <tr>
              <th class="fg-secondary fw-normal">Ubigeo Nacimiento</th>
              <td
                >{data.persona.lugar_nacimiento == null
                  ? ""
                  : data.persona.lugar_nacimiento}</td
              >
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  {/if}
</div>
